import { render, staticRenderFns } from "./BindAccount.vue?vue&type=template&id=2bb484d0&"
import script from "./BindAccount.vue?vue&type=script&lang=js&"
export * from "./BindAccount.vue?vue&type=script&lang=js&"
import style0 from "./BindAccount.vue?vue&type=style&index=0&id=2bb484d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports